import { JiraFromUI } from '@app/booking-frontend-libs';
import { ErrorMessage, Spinner } from '@forge/react';
import React, { useEffect, useReducer, useRef } from 'react';
import { getConfirmedStatuses } from '../shared';
import { useFieldOptions } from '../../libs/useFieldOptions';
import { SuggestionsBox } from './SuggestionsBox';
const MAX_DISPLAY_SUGGESTIONS = 5;
function reducer(state, action) {
    var _a, _b;
    switch (action.type) {
        case 'error':
            return {
                isInitialRun: false,
                working: false,
                availableOptions: [],
                error: ((_a = action.payload) === null || _a === void 0 ? void 0 : _a.error) || ''
            };
        case 'loading':
            return { ...state, isInitialRun: false, working: true, error: '' };
        case 'not-loading':
            return { ...state, isInitialRun: false, working: false, error: '' };
        case 'results':
            return { ...state, isInitialRun: false, working: false, availableOptions: ((_b = action.payload) === null || _b === void 0 ? void 0 : _b.availableOptions) || [] };
    }
    return state;
}
export function SelectSuggestion(props) {
    const timeout = useRef(null);
    const [state, dispatch] = useReducer(reducer, {
        isInitialRun: true,
        working: false,
        error: '',
        availableOptions: []
    });
    const { selectOptions } = useFieldOptions(props.configuration);
    // biome-ignore lint/correctness/useExhaustiveDependencies: we are only interested in changes of the specified variables
    useEffect(() => {
        async function load() {
            if (props.userEndTime.localeCompare(props.userStartTime) > 0) {
                dispatch({ type: 'loading' });
                const r = await JiraFromUI.fetchIssuesFromConfiguration(props.configuration, {
                    startDate: props.userStartTime,
                    endDate: props.userEndTime,
                    statusesIds: getConfirmedStatuses(props.configuration)
                });
                const availableResources = r.reduce((acc, r) => {
                    const resource = r.fields[props.configuration.resourceFieldId];
                    return acc.filter((r) => r.value !== resource.id);
                }, selectOptions);
                dispatch({
                    type: 'results',
                    payload: {
                        availableOptions: availableResources.filter((r) => r.value !== props.resource)
                    }
                });
            }
            else {
                dispatch({ type: 'not-loading' });
            }
        }
        dispatch({ type: 'loading' });
        if (state.isInitialRun) {
            load();
        }
        else {
            clearTimeout(timeout.current);
            timeout.current = setTimeout(() => load(), 500);
        }
        return () => {
            clearTimeout(timeout.current);
        };
    }, [props.resource, selectOptions, props.userStartTime, props.userEndTime]);
    const { working, error, availableOptions } = state;
    if (selectOptions.length === 0) {
        return null;
    }
    if (!(working || availableOptions.length) && props.resource) {
        return null;
    }
    if (state.isInitialRun) {
        return null;
    }
    if (working) {
        return React.createElement(Spinner, null);
    }
    if (error) {
        return React.createElement(ErrorMessage, null, error);
    }
    return (React.createElement(SuggestionsBox, { hasSelection: Boolean(props.resource), suggestions: availableOptions, onSelect: props.onSelect }));
}
